module.exports = "/fonts/fa-regular-400.svg?d3d070c219ac57dafb23b27c27518506";